<template>
  <div>

  </div>
</template>
<script>
import {getSignPackage} from "../../api/index";
export default {
  props:{
    share_detail:Object,
  },
  data(){
     return {

     }
  },
  mounted(){
    this.getShareInfo()
  },
  methods:{

    getShareInfo(tit,fxUrl){//如果分享的内容会根据情况变化，那么这里可以传入分享标题及url
     var _this = this;
      var data={//请求参数
        url : this.share_detail.jmUrl
      }
      getSignPackage(data)//这里我写了一个公用的接口请求js，这里正常axios请求就可以，只要拿到数据都可以
          .then(res => {
            //拿到后端给的这些数据
            let appId = res.data.data.appId;
            let timestamp = res.data.data.timestamp;
            let nonceStr = res.data.data.nonceStr;
            let signature = res.data.data.signature;
            wx.config({
              debug: false,// 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: appId,         // 必填，公众号的唯一标识，填自己的！
              timestamp: timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
              nonceStr: nonceStr,   // 必填，生成签名的随机串
              signature: signature, // 必填，签名，见附录1
              jsApiList: res.data.data.jsApiList
            })
            wx.error(function(){
              window.location.reload()
             });
            wx.ready(function () {
              wx.onMenuShareTimeline({
                title: _this.share_detail.title, // 分享标题
                link: _this.share_detail.jmUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: _this.share_detail.imgUrl, // 分享图标
                success: function () {
                // 用户点击了分享后执行的回调函数
                }
              })
              wx.onMenuShareAppMessage({
                 title: _this.share_detail.title, // 分享标题
                 desc: _this.share_detail.title, // 分享描述
                 link: _this.share_detail.jmUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                 imgUrl: _this.share_detail.imgUrl, // 分享图标
                 type: '', // 分享类型,music、video或link，不填默认为link
                 dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                 success: function () {
                   // 用户点击了分享后执行的回调函数
                 }
               });

                //分享到朋友圈
                wx.updateTimelineShareData({
                  title: _this.share_detail.title,   // 分享时的标题
                  link: _this.share_detail.jmUrl,     // 分享时的链接
                  imgUrl: _this.share_detail.imgUrl,    // 分享时的图标
                  success: function () {
                    console.log("分享成功2");
                  },
                  cancel: function () {
                    console.log("取消分享");
                  }
                });
                //分享给朋友
                wx.updateAppMessageShareData({
                  title: _this.share_detail.title,
                  desc: _this.share_detail.title,
                  link: _this.share_detail.jmUrl,
                  imgUrl: _this.share_detail.imgUrl,
                  success: function () {
                    console.log("分享成功1");
                  },
                  cancel: function () {
                    console.log("取消分享");
                  }
                });
            })
      })
   }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/common/share.vue